// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import meetingAgendaItemEntity from './entities/meeting-agenda-item.json';
import meetingAgendaItemMenu from '../pages/meeting-agenda-item/menu.json';
import meetingAgendaItemFullForm from '../pages/meeting-agenda-item/forms/full.json';
import meetingAgendaItemContextForm from '../pages/meeting-agenda-item/forms/context.json';
import meetingAgendaItemMiniForm from '../pages/meeting-agenda-item/forms/mini.json';
import meetingAgendaItemLookupForm from '../pages/meeting-agenda-item/forms/lookup.json';
import meetingAgendaItemTableView from '../pages/meeting-agenda-item/views/table.json';
import meetingAgendaItemCardsView from '../pages/meeting-agenda-item/views/cards.json';
import meetingAgendaItemDashboardView from '../pages/meeting-agenda-item/views/dashboard.json';

/** Тип запису «Питання порядку денного» зі сторінками пакета: меню, форми та подання з pages/meeting-agenda-item/. */
export const meetingAgendaItemDefinition: IRecordTypeDefinition = {
  ...meetingAgendaItemEntity,
  views: assembleViewSet({
      table: meetingAgendaItemTableView,
      cards: meetingAgendaItemCardsView,
      dashboard: meetingAgendaItemDashboardView,
  }),
  form: meetingAgendaItemFullForm,
  forms: { full: meetingAgendaItemFullForm, context: meetingAgendaItemContextForm, mini: meetingAgendaItemMiniForm, lookup: meetingAgendaItemLookupForm },
  menu: meetingAgendaItemMenu,
} as IRecordTypeDefinition;
